import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

type CurrentPlatform = 'browser' | 'native';


@Injectable({
  providedIn: 'root'
})
export class CurrentPlatformService {

  private _currentPlatform: CurrentPlatform;

  constructor(private platform: Platform) {
    this.setCurrentPlatform();
  }

  private setCurrentPlatform() {
    const platform = Capacitor.getPlatform();
    if(platform === 'ios' || platform === 'android') this._currentPlatform = 'native';
    else this._currentPlatform = 'browser';
  }

  get currentPlatform() {
    return this._currentPlatform;
  }

  isNative() {
    return this._currentPlatform === 'native';
  }
  isBrowser() {
    return this._currentPlatform === 'browser';
  }

  isIOS(){
    return this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone');
  }
  isAndroid(){
    return this.platform.is('android') || this.platform.is('tablet');
  }


}
